<template>
  <div class="footer">
    <img v-show="isShow" class="bg" src="~@/assets/img/itles-webapp-videoClass/footer.png" alt />
    <div v-if="checkIos" class="price" />
    <div v-else class="price">
      <span class="price-symbol">￥</span>
      <span class="price-info">{{ current_price }}</span>
      <span class="price-old" v-if="original_price != 0 && original_price != '0.00'">原价:{{ original_price }}</span>
    </div>
    <div class="btn-conent">
      <van-button v-if="!hasGet" @click="freeGet" round class="btn" color="#FF9F00">立即报名</van-button>
      <van-button v-else round @click="goClass" class="btn" color="#6C39C8">进入课程</van-button>
    </div>
  </div>
</template>
<script>
import { isIos } from "@/utils/utils.js";

export default {
  props: ['current_price', 'original_price', 'hasGet'],
  data() {
    return {
      isShow: false,
      checkIos: false
    };
  },
  created() {
    this.checkIos = isIos();    
  },
  methods: {
    freeGet() {
      this.$emit('handleClick_freeGet');
    },
    goClass() {
      this.$emit('handleClick_goClass');
    },
    scroll_event() {
      let doc = document.documentElement || document.body;
      let scrollTop = doc.scrollTop;
      let scrollHeight = doc.scrollHeight;
      let clientHeight = doc.clientHeight;
      if (scrollTop + clientHeight == scrollHeight) {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    },
    scroll_event_bind() {
      window.addEventListener('scroll', this.scroll_event, false);
    },
    scroll_event_unbind() {
      window.removeEventListener('scroll', this.scroll_event, false);
    }
  },
  mounted() {
    this.scroll_event_bind();
  },
  destroyed() {
    this.scroll_event_unbind();
  }
};
</script>
<style lang="scss" scoped>
.footer {
  width: 100%;
  height: tovw(144);
  background-color: #fff;
  box-shadow: 0px -12px 16px 0px rgba(0, 0, 0, 0.04);
  position: fixed;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .bg {
    width: 100%;
    height: tovw(100);
    position: absolute;
    left: 0;
    top: tovw(-100);
  }
  .price {
    width: 60%;
    line-height: tovw(144);
    font-family: DINAlternate-Bold, DINAlternate;
    font-weight: bold;
    color: #ff7f00;
    .price-symbol {
      margin-left: tovw(40);
      font-size: tovw(48);
    }
    .price-info {
      font-size: tovw(50);
    }
    .price-old {
      font-size: tovw(24);
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.35);
      margin-left: tovw(20);
      text-decoration: line-through;
    }
  }

  .btn-conent {
    width: 40%;
    .btn {
      width: tovw(264);
      height: tovw(96);
      font-size: tovw(34);
    }
  }
}
</style>
